import type { QuestionOutlineItem } from '@/contracts/question-groups'
import type { ContractSourceMeta, QuestionGroupUiContract } from '@/contracts/questionnaire'
import type { Form, LogicJump, Question } from '@/types/form'
import { z } from 'zod'

export const MIAOLIN_CUSTOMER_ONBOARDING_TEMPLATE_ID =
  '44444444-4444-4444-8444-444444444444'

export const FormTemplateStatusSchema = z.enum(['active', 'archived'])
export type FormTemplateStatus = z.infer<typeof FormTemplateStatusSchema>

export type FormTemplateSnapshotContract = {
  form: Form
  questions: Question[]
  logicJumps: LogicJump[]
  groups: QuestionGroupUiContract[]
  outline: QuestionOutlineItem[]
  hiddenFields: Record<string, string>
}

export type FormTemplateContract = {
  id: string
  workspaceId: string
  title: string
  description: string
  category: string
  status: FormTemplateStatus
  isSystem: boolean
  sourceFormId?: string
  questionCount: number
  groupCount: number
  updatedAt: string
  createdBy?: string
  sourceMeta: ContractSourceMeta
}

export type FormTemplateDetailContract = FormTemplateContract & {
  snapshot: FormTemplateSnapshotContract
}

export type FormTemplateListResult = {
  data: FormTemplateContract[]
  meta: ContractSourceMeta & {
    total: number
  }
}

export type CreateFormTemplateInput = {
  title: string
  description?: string
  category?: string
  sourceFormId?: string
  snapshot?: FormTemplateSnapshotContract
}

export type PatchFormTemplateInput = Partial<
  Pick<CreateFormTemplateInput, 'title' | 'description' | 'category' | 'snapshot'>
> & {
  status?: FormTemplateStatus
}

export type CreateFormFromTemplateInput = {
  title?: string
  description?: string
}
